import * as CommunicationType from "./CommunicationType";

export {CommunicationType};